import { ISectionMenuItem } from "components/PageTopNav";
import { useEnvContext, useWebStoreContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useAppDispatch, useAppSelector } from "hooks";
import { usePopupsState } from "hooks/usePopupsState";
import { useEffect, useState } from "react";
import {
	onOpenPopUp,
	onOpenPopUpV2,
	onSeeFullTutorialAgain,
	selectCommonState
} from "redux/slices";

interface IUseTriggerLPFTUEProps {
	sectionMenuData?: ISectionMenuItem[];
}

export const useTriggerLPFTUE = ({
	sectionMenuData
}: IUseTriggerLPFTUEProps): void => {
	const dispatch = useAppDispatch();
	const { isFeatureFlagEnabled, isFeatureFlagsReady } = useEnvContext();
	const isFtueV2Enabled = isFeatureFlagEnabled(FeaturesFlags.FTUE_V2);
	const { authToken, userTracker } = useWebStoreContext();
	const areFeatureFlagsReady = isFeatureFlagsReady(authToken?.value);
	const [tutorialFlag, setTutorialFlag] = useState<boolean>(false);
	const { seeFullTutorialAgain } = useAppSelector(selectCommonState);
	const shouldReplayLegacyTutorial = !isFtueV2Enabled && seeFullTutorialAgain;
	const {
		isAnyDipOpen,
		isDipPriorityPending,
		isAnyPopupOpen,
		isMegaMenuOpen,
		isWelcomeFlowActive,
		IsInAppToWebDipChecking,
		IsFriendReferralAcceptInviteChecking
	} = usePopupsState();
	const isLoyaltyFtueEnabled =
		isFtueV2Enabled || isFeatureFlagEnabled(FeaturesFlags.LOYALTY_SHOP_FTUE);

	const openTutorial = () => {
		if (isFtueV2Enabled) {
			dispatch(
				onOpenPopUpV2({
					variant: "tutorial-loyalty-shop-v2",
					id: "tutorial-loyalty-shop-v2",
					replaceIfExists: true
				})
			);
			return;
		}
		if (shouldReplayLegacyTutorial) {
			dispatch(onSeeFullTutorialAgain(false));
		}
		dispatch(onOpenPopUp("tutorial-loyalty-shop"));
	};

	const displayFTUE = async () => {
		if (!authToken?.value || !userTracker || !areFeatureFlagsReady) {
			return;
		}
		if (
			sectionMenuData?.length === 0 ||
			(tutorialFlag && !shouldReplayLegacyTutorial) ||
			!isLoyaltyFtueEnabled ||
			(userTracker?.metadata?.hasSeenLPTutorial === "true" &&
				!shouldReplayLegacyTutorial) ||
			isAnyPopupOpen ||
			isDipPriorityPending ||
			isAnyDipOpen ||
			IsInAppToWebDipChecking ||
			IsFriendReferralAcceptInviteChecking ||
			isWelcomeFlowActive ||
			isMegaMenuOpen
		) {
			return;
		}
		setTutorialFlag(true);
		openTutorial();
		//await postMetadata({ key: "hasSeenLPTutorial", value: "true" }).unwrap();
		//await syncUserTracker();
	};

	useEffect(() => {
		displayFTUE();
	}, [
		authToken?.value,
		areFeatureFlagsReady,
		sectionMenuData,
		userTracker?.metadata?.hasSeenLPTutorial,
		isAnyPopupOpen,
		IsInAppToWebDipChecking,
		IsFriendReferralAcceptInviteChecking,
		isWelcomeFlowActive,
		seeFullTutorialAgain,
		isMegaMenuOpen,
		isDipPriorityPending,
		isAnyDipOpen,
		isLoyaltyFtueEnabled,
		isFtueV2Enabled
	]);
};
